import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import ReactMarkdown from "react-markdown";

import { copy } from "../../utils/clipboard";

export const copyMarkdownToClipboard = (
  outputText: string | null | undefined
): void => {
  if (!outputText) return;
  // Strip out markdown links, and optional a preceding " ", ",", or " ,",
  // otherwise we leave extra whitespace in the copied text before the period.
  const plain = outputText.replaceAll(/ ?,?\[[^\]]+\]\([^)]*\)/g, "");
  const html = renderToStaticMarkup(
    <ReactMarkdown>{outputText}</ReactMarkdown>
  );
  copy({ plain, html });
};
